import { AccountInfo, InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";
import axios, { AxiosError } from "axios";
import { AccountService } from "./accounts/services/AccountService";
import { msalConfig } from "./accounts/types/msalAuthConfig";

const axiosInstance = axios.create();

export const handleAxiosError = async (error: AxiosError, msalInstance: IPublicClientApplication) => {
   if (error instanceof InteractionRequiredAuthError) {
        await msalInstance.acquireTokenRedirect({
            scopes: [msalConfig.auth.scope]
        });
    } 
    else if (error?.response?.status === 401) {
        await AccountService.logout();
        window.location.replace("/signOut");
    } 
    else if (error?.response?.status === 500) {
        throw error.response.data["message"];
    }

    return Promise.reject(error);
}

export const attachAxiosErrorInterceptor = (msalInstance: IPublicClientApplication) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error: AxiosError) => handleAxiosError(error, msalInstance)
    );
};

// I have just moved these here for now, but we need to review the usage of these request interceptors, there is repeated logic
export const attachMatchingEngineMsalInterceptor = (msalInstance: IPublicClientApplication, account: AccountInfo) => {
    let scope = { scopes: [msalConfig.auth.scope] };

    const interceptor = async (config) => {
        const url = config.url;
        if (url && (url.includes('http://') || url.includes('https://'))) {
            return config;
        }

        if (!account) {
            throw Error('No active account! Verify a user has been signed in.');
        }

        const response = await msalInstance.acquireTokenSilent({
            ...scope,
            account,
        });

        const bearer = `Bearer ${response.accessToken}`;
        config.headers.Authorization = bearer;

        return config;
    }
    axiosInstance.interceptors.request.use(interceptor);
}

export const attachMembersPortalMsalInterceptor = (msalInstance: IPublicClientApplication, account: AccountInfo) => {
    let scope = {
        scopes: [],
        extraScopesToConsent: [msalConfig.auth.scope]
    };

    let authority = msalConfig.auth.authority

    const interceptor = async (config) => {
        const url = config.url;
        if (url && (url.includes('http://') || url.includes('https://'))) {
            return config;
        }

        const response = await msalInstance.acquireTokenSilent({
            ...scope,
            account,
            authority
        });

        const bearer = `Bearer ${response.idToken}`;
        config.headers.Authorization = bearer;

        return config;
    }
    axiosInstance.interceptors.request.use(interceptor);
}

export const attachBearerHeaderFromAADLoginInterceptor = (msalInstance: IPublicClientApplication, account: AccountInfo) => {
    axiosInstance.interceptors.request.use(async (config) => {
        const url = config.url;
        if (url && (url.includes('http://') || url.includes('https://'))) {
            return config;
        }

        if (!account) {
            return config;
        }

        let scope =
        {
            scopes: [msalConfig.auth.scope]
        }

        const response = await msalInstance.acquireTokenSilent({
            ...scope,
            account,
        });

        const bearer = `Bearer ${response.accessToken}`;
        config.headers.Authorization = bearer;

        return config;
    });
} 

export default axiosInstance;